import { render, staticRenderFns } from "./MatrizBase.vue?vue&type=template&id=4c274606&"
import script from "./MatrizBase.vue?vue&type=script&lang=ts&"
export * from "./MatrizBase.vue?vue&type=script&lang=ts&"
import style0 from "./MatrizBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports